import React from "react";
import { HiTrophy, HiUserGroup, HiBeaker } from "react-icons/hi2";
import { PerformanceType } from "../../types/post";
import { performanceTypeLabel } from "../../types/event";

/**
 * Intent badge (Competition / Game Day / Testing) shared by the diary card,
 * Performances list, Schedule and the flow summary — one look everywhere.
 */
const PerformanceIntentBadge: React.FC<{
  type: PerformanceType | undefined;
  size?: "sm" | "md";
  className?: string;
}> = ({ type, size = "sm", className = "" }) => {
  if (!type) return null;
  const Icon =
    type === "competition" ? HiTrophy : type === "gameDay" ? HiUserGroup : HiBeaker;
  const tone =
    type === "competition"
      ? "bg-primary/15 text-primary"
      : type === "gameDay"
        ? "bg-info/15 text-info"
        : "bg-base-300 text-base-content/70";
  return (
    <span
      className={`inline-flex items-center gap-1 rounded-full font-bold uppercase tracking-wide font-geist ${
        size === "sm" ? "px-2 py-0.5 text-[10px]" : "px-2.5 py-1 text-xs"
      } ${tone} ${className}`}
    >
      <Icon className={size === "sm" ? "w-3 h-3" : "w-3.5 h-3.5"} />
      {performanceTypeLabel(type)}
    </span>
  );
};

export default PerformanceIntentBadge;
